import { APP_NAME } from "@calcom/lib/constants";
import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src = "/api/logo",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  if (icon) {
    return (
      <h3 className={classNames("logo", inline && "inline", className)}>
        <strong>
          <img
            className="mx-auto h-9 w-9"
            alt={APP_NAME}
            title={APP_NAME}
            src={`${src}?type=icon`}
          />
        </strong>
      </h3>
    );
  }

  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong className="text-emphasis inline-flex items-center gap-2">
        <img
          className={classNames(small ? "h-5 w-5" : "h-6 w-6")}
          alt=""
          src="/mybookslot-symbol.png"
        />
        <span className={classNames(small ? "text-sm" : "text-base", "font-semibold tracking-tight")}>
          {APP_NAME}
        </span>
      </strong>
    </h3>
  );
}
